// extracted by mini-css-extract-plugin
module.exports = {"open_link":"about_open_link__1ez1y","modal":"about_modal__1jdnT","responsive_table":"about_responsive_table__2JFen"};